interface AdMarkerProps {
  position: string
  recommendedSize?: string
  notes?: string
  className?: string
}

import { isDev } from "@/lib/utils/is-dev"

export default function AdMarker({ position, recommendedSize = "Responsive", notes, className = "" }: AdMarkerProps) {
  // Only show in development (SST dev mode or non-production stages)
  if (!isDev()) {
    return null
  }

  return (
    <div
      className={`relative border-2 border-dashed border-blue-500 bg-blue-50 p-4 ${className}`}
      style={{ minHeight: "100px" }}
    >
      <div className="absolute left-2 top-2 rounded bg-blue-500 px-2 py-1 text-xs font-bold text-white">AD MARKER</div>
      <div className="mt-6 text-center">
        <p className="text-sm font-semibold text-blue-700">Position: {position}</p>
        <p className="text-xs text-blue-600">Recommended Size: {recommendedSize}</p>
        {notes && <p className="mt-2 text-xs italic text-gray-600">{notes}</p>}
      </div>
    </div>
  )
}
